<template>
  <modal
    :classes="[
      'app-slideover',
      hasCustomTheme
        ? $theme.darkTheme
          ? 'bg-color-modal-dark'
          : 'bg-color-modal-light'
        : 'bg-color-modal-light'
    ]"
    name="subscriptions"
    height="100%"
    :width="calculatedWidth"
    :adaptive="true"
    :pivotX="1"
    :shiftX="1"
    :scrollable="true"
    @opened="load()"
    @before-close="closing()"
    transition="slide-left"
    overlayTransition
  >
    <HeaderPage pageName="Assinaturas" modalName="subscriptions" />

    <main
      style="color: gray !important"
      :class="
        hasCustomTheme
          ? $theme.darkTheme
            ? 'bg-color-modal-dark'
            : 'bg-color-modal-light'
          : 'bg-color-modal-light'
      "
    >
      <div class="container">
        <div
          class="item-title"
          :style="!hasCustomTheme ? '#0564b1' : { color: $theme.primaryColor }"
        >
          Ativas
        </div>

        <div class="row" style="margin-bottom: 0">
          <ul
            v-if="parsedSubscriptions.active.length"
            class="col s12 no-padding"
            style="margin-bottom: 0"
          >
            <li
              v-for="subscription in parsedSubscriptions.active"
              :key="subscription.id"
            >
              <SubscriptionCard
                :id="subscription.id"
                :title="subscription.courseName"
                :status="subscription.status"
                :nextBillingDate="subscription.nextBillingDate"
                :expirationDate="subscription.expirationDate"
              />
            </li>
          </ul>
          <p v-else>Nenhuma assinatura ativa encontrada</p>
        </div>
      </div>

      <hr style="opacity: 0.6" />

      <div class="container">
        <div
          class="item-title"
          :style="!hasCustomTheme ? '#0564b1' : { color: $theme.primaryColor }"
        >
          Inativas
        </div>
        <div class="item-description grey-text"></div>

        <div class="row">
          <ul
            v-if="parsedSubscriptions.inactive.length"
            class="col s12 no-padding"
          >
            <li
              v-for="subscription in parsedSubscriptions.inactive"
              :key="subscription.id"
            >
              <SubscriptionCard
                :id="subscription.id"
                :title="subscription.courseName"
                :status="subscription.status"
                :nextBillingDate="subscription.nextBillingDate"
                :expirationDate="subscription.expirationDate"
              />
            </li>
          </ul>

          <p v-else>Nenhuma assinatura inativa encontrada</p>
        </div>
      </div>
    </main>
  </modal>
</template>

<script>
import SubscriptionCard from "@/components/SubscriptionCard.vue";
import HeaderPage from "@/layout/HeaderPage";
import { isIOS, isMobile } from "mobile-device-detect";
import { mapState } from "vuex";

export default {
  name: "SubscriptionsModal",
  props: ["layoutTheme"],
  components: {
    SubscriptionCard,
    HeaderPage,
  },
  methods: {
    load() {
      this.userProfile = this.currentProfile;
    },

    closing() {
      if (isIOS) {
        this.iosModalHack(false);
      }
    },

    iosModalHack(fixedBody) {
      document.querySelector("body").style.position = fixedBody ? "fixed" : "";
    },
  },
  computed: {
    ...mapState({
      subscriptions: (state) => state.subscription.subscriptions,
      selectedEnroll: (state) => state.enroll.current,
    }),

    parsedSubscriptions() {
      const activeStatuses = ["Ativa", "Atrasada"];
      return (this.subscriptions||[]).reduce(
        (acc, current) => {
          if (activeStatuses.includes(current.status)) acc.active.push(current);
          else acc.inactive.push(current);

          return acc;
        },
        { active: [], inactive: [] }
      );
    },

    hasCustomTheme() {
      const isTrustflix = this.$route.name === "trustflix";
      return this.selectedEnroll || isTrustflix;
    },
    calculatedWidth() {
      if (isMobile) return "100%";
      else return "300px";
    },
  },
};
</script>

<style scoped>
.container {
  width: 85% !important;
}
</style>
